import { BusyState } from './types'

export const initialBusyState: BusyState = {
	blockers: 0,
	nonblockers: 0,
	isBusy: false
}
